// 말소 보강서류 인박스 (수출업체) — 말소대행업체가 요청한 보강서류 확인 + 제출 + 메시지 (2026-06-18)
//   백엔드: GET /cancel-doc-requests/my, POST /cancel-doc-requests/:id/submit(멀티파트=첨부+제출),
//           GET/POST /cancel-doc-requests/:id/messages
import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';
import { getSocket } from '../utils/socket';

var NAVY = '#1B3A5C';
var STATUS_C = { '요청': { bg: '#fef2f2', bd: '#dc2626', t: '#b91c1c', label: '제출 대기' }, '제출': { bg: '#eff6ff', bd: '#2563eb', t: '#1d4ed8', label: '대행사 확인 대기' }, '완료': { bg: '#f0fdf4', bd: '#16a34a', t: '#15803d', label: '완료' } };

function CancelDocInbox({ showToast, user }) {
  var st = showToast || function () {};
  var itemsState = useState([]); var items = itemsState[0]; var setItems = itemsState[1];
  var loadingState = useState(true); var loading = loadingState[0]; var setLoading = loadingState[1];
  var upState = useState(0); var uploadingId = upState[0]; var setUploadingId = upState[1];
  var msgOpenState = useState(0); var msgOpenId = msgOpenState[0]; var setMsgOpenId = msgOpenState[1];
  var msgsState = useState([]); var msgs = msgsState[0]; var setMsgs = msgsState[1];
  var msgTextState = useState(''); var msgText = msgTextState[0]; var setMsgText = msgTextState[1];

  function load() {
    authFetch(API + '/cancel-doc-requests/my').then(function (r) { return r.json(); })
      .then(function (d) { setItems(Array.isArray(d) ? d : []); setLoading(false); })
      .catch(function () { setLoading(false); });
  }
  useEffect(function () { load(); }, []);
  useEffect(function () {
    var sock = getSocket(); if (!sock) return;
    function onReq() { load(); }
    sock.on('cancel-doc:requested', onReq);
    sock.on('cancel-doc:message', onReq);
    sock.on('cancel-doc:cancelled', onReq);   // 대행사 취소 시 인박스에서 즉시 제거(reload → 백엔드 필터)
    return function () { try { sock.off('cancel-doc:requested', onReq); sock.off('cancel-doc:message', onReq); sock.off('cancel-doc:cancelled', onReq); } catch (e) {} };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 파일 선택 즉시 제출(첨부+제출 한 번에) — 백엔드 /submit 가 addFiles + status='제출'
  function submitFiles(it, fileList) {
    var files = Array.prototype.slice.call(fileList || []);
    if (files.length === 0 || uploadingId) return;
    setUploadingId(it.id);
    var fd = new FormData();
    files.forEach(function (f) { fd.append('files', f); });
    authFetch(API + '/cancel-doc-requests/' + it.id + '/submit', { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        setUploadingId(0);
        if (d && d.success) { st('서류 ' + files.length + '개 제출 완료 — 대행업체가 확인합니다', ''); load(); }
        else st((d && d.error) || '제출 실패', 'err');
      }).catch(function () { setUploadingId(0); st('제출 실패', 'err'); });
  }

  function openMsg(it) {
    if (msgOpenId === it.id) { setMsgOpenId(0); setMsgs([]); return; }
    setMsgOpenId(it.id); setMsgs([]); setMsgText('');
    authFetch(API + '/cancel-doc-requests/' + it.id + '/messages').then(function (r) { return r.json(); }).then(function (d) { setMsgs(Array.isArray(d) ? d : []); }).catch(function () {});
  }
  function sendMsg(it) {
    var body = (msgText || '').trim(); if (!body) return;
    authFetch(API + '/cancel-doc-requests/' + it.id + '/messages', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ body: body }) })
      .then(function (r) { return r.json(); }).then(function (d) {
        if (d && d.success) { setMsgText(''); authFetch(API + '/cancel-doc-requests/' + it.id + '/messages').then(function (r) { return r.json(); }).then(function (m) { setMsgs(Array.isArray(m) ? m : []); }); }
        else st((d && d.error) || '전송 실패', 'err');
      }).catch(function () { st('전송 실패', 'err'); });
  }

  return (
    <div style={{ padding: '20px 24px', maxWidth: 1000, margin: '0 auto' }}>
      <div style={{ fontSize: 22, fontWeight: 800, color: NAVY, marginBottom: 4 }}>{'📋 말소 보강서류 요청'}</div>
      <div style={{ fontSize: 12, color: '#64748b', marginBottom: 20, lineHeight: 1.6 }}>
        {'말소대행업체가 말소 진행에 필요한 서류를 요청한 건입니다. '}<b style={{ color: '#2563eb' }}>{'📎 서류 제출'}</b>{'로 파일을 올리면 대행업체로 바로 전달됩니다.'}</div>

      {loading && <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>{'불러오는 중...'}</div>}
      {!loading && items.length === 0 && (
        <div style={{ padding: 50, textAlign: 'center', color: '#94a3b8', background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb' }}>
          <div style={{ fontSize: 32, opacity: 0.4 }}>{'✅'}</div>
          <div style={{ marginTop: 8 }}>{'보강서류 요청이 없습니다'}</div>
        </div>
      )}
      {!loading && items.map(function (it) {
        var sc = STATUS_C[it.status] || STATUS_C['요청'];
        var docs = it.requestedDocs || [];
        return (
          <div key={it.id} style={{ background: '#fff', border: '1px solid #e5e7eb', borderLeft: '4px solid ' + sc.bd, borderRadius: 10, padding: '14px 18px', marginBottom: 10 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap' }}>
              <div style={{ flex: 1, minWidth: 200 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                  <span style={{ fontSize: 16, fontWeight: 800, color: NAVY }}>{it.carNo || '-'}</span>
                  <span style={{ fontSize: 12, color: '#64748b' }}>{it.carType || ''}</span>
                  <span style={{ fontSize: 11, fontWeight: 700, color: sc.t, background: sc.bg, border: '1px solid ' + sc.bd, borderRadius: 10, padding: '2px 8px' }}>{sc.label}</span>
                </div>
                <div style={{ fontSize: 12, color: '#64748b' }}>{'대행업체: ' + (it.agencyName || '-') + '  ·  요청일: ' + (it.requestedAt || '-')}</div>
                {docs.length > 0 && (
                  <div style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'center' }}>
                    <span style={{ fontSize: 11, color: '#b91c1c', fontWeight: 700 }}>{'요청 서류:'}</span>
                    {docs.map(function (d, i) { return <span key={i} style={{ fontSize: 11, color: '#7f1d1d', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 6, padding: '3px 8px' }}>{d}</span>; })}
                  </div>
                )}
                {it.memo && <div style={{ fontSize: 13, color: '#7f1d1d', background: '#fef2f2', borderRadius: 6, padding: '8px 10px', marginTop: 8 }}>{'📝 ' + it.memo}</div>}
                {it.files && it.files.length > 0 && (
                  <div style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'center' }}>
                    <span style={{ fontSize: 11, color: '#16a34a', fontWeight: 700 }}>{'제출 ' + it.files.length + '개:'}</span>
                    {it.files.map(function (f) { return <span key={f.id} title={f.originalName} style={{ fontSize: 11, color: '#1d4ed8', background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 6, padding: '3px 8px', maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{'📎 ' + f.originalName}</span>; })}
                  </div>
                )}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                {it.status !== '완료' && <>
                  <input id={'cdfile-' + it.id} type="file" multiple style={{ display: 'none' }} onChange={function (e) { submitFiles(it, e.target.files); e.target.value = ''; }} />
                  <label htmlFor={'cdfile-' + it.id} style={{ padding: '8px 14px', background: uploadingId === it.id ? '#93c5fd' : '#2563eb', color: '#fff', borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: uploadingId === it.id ? 'default' : 'pointer', whiteSpace: 'nowrap', textAlign: 'center' }}>{uploadingId === it.id ? '제출 중...' : '📎 서류 제출'}</label>
                </>}
                <button onClick={function () { openMsg(it); }} style={{ padding: '8px 14px', background: '#f1f5f9', color: NAVY, border: '1px solid #cbd5e1', borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' }}>{'💬 메시지' + (it.messageCount ? ' (' + it.messageCount + ')' : '')}</button>
              </div>
            </div>
            {msgOpenId === it.id && (
              <div style={{ marginTop: 12, borderTop: '1px solid #e5e7eb', paddingTop: 10 }}>
                <div style={{ maxHeight: 200, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 8 }}>
                  {msgs.length === 0 && <div style={{ fontSize: 12, color: '#94a3b8', textAlign: 'center', padding: 8 }}>{'메시지가 없습니다'}</div>}
                  {msgs.map(function (m) {
                    var mine = m.sender === 'company';
                    return <div key={m.id} style={{ alignSelf: mine ? 'flex-end' : 'flex-start', maxWidth: '75%', background: mine ? '#2563eb' : '#f1f5f9', color: mine ? '#fff' : '#1e293b', borderRadius: 10, padding: '6px 10px', fontSize: 13 }}>{m.body}<div style={{ fontSize: 9, opacity: 0.7, marginTop: 2 }}>{(mine ? '나' : '대행업체') + ' · ' + (m.createdAt || '')}</div></div>;
                  })}
                </div>
                <div style={{ display: 'flex', gap: 6 }}>
                  <input value={msgText} onChange={function (e) { setMsgText(e.target.value); }} onKeyDown={function (e) { if (e.key === 'Enter') sendMsg(it); }} placeholder="메시지 입력..." style={{ flex: 1, padding: '8px 10px', border: '1px solid #d0d5dd', borderRadius: 8, fontSize: 13, outline: 'none' }} />
                  <button onClick={function () { sendMsg(it); }} style={{ padding: '8px 16px', background: NAVY, color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>{'전송'}</button>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default CancelDocInbox;
